import { atom } from "jotai";

import { TimeLookbackRange } from "@shared/types";

export const tlrAtom = atom<TimeLookbackRange>("All time");
